import { IFilterState } from "../common/interfaces";
import { getLocalizedText } from "../common/translations";
import { removeChildren } from "../common/utilities";
import ControlBase, { IControlBaseOptions } from "./controlBase";

interface IFilterControlOptions extends IControlBaseOptions {
    filterStateChangeHandler?: (newState: IFilterState) => any
}

export default class FilterControl extends ControlBase {
    optionsList: HTMLUListElement;
    typeOptionsList: HTMLUListElement;
    filterStateChangeHandler: (newState: IFilterState) => any;

    constructor(options: IFilterControlOptions) {
        let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // Bootstrap ikona Funnel https://icons.getbootstrap.com/icons/funnel/
        svg.innerHTML = `<path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z"/>`;
        svg.setAttribute("width", "24px");
        svg.setAttribute("height", "24px");
        svg.setAttribute("viewBox", "0 0 16 16");
        options.symbol = svg;
        options.collapsible = true;
        options.tooltipText = getLocalizedText("controlFilter");
        super(options);

        this.filterStateChangeHandler = options.filterStateChangeHandler;

        this.optionsList = document.createElement("ul");
        this.optionsList.id = "map-filter-options";
        let container = document.createElement("li");
        this.generateCheckBox("optUnpaid", getLocalizedText("controlUnpaidGravesFilter"), false, this.handleFilterStateChanged.bind(this), container);
        this.optionsList.appendChild(container);
        container = document.createElement("li");
        this.generateCheckBox("optNoContract", getLocalizedText("controlNoContractFilter"), false, this.handleFilterStateChanged.bind(this), container);
        this.optionsList.appendChild(container);
        container = document.createElement("li");
        this.generateCheckBox("optEmpty", getLocalizedText("controlEmptyGravesFilter"), false, this.handleFilterStateChanged.bind(this), container);
        this.optionsList.appendChild(container);
        container = document.createElement("li");
        this.generateCheckBox("optProjected", getLocalizedText("controlProjectedGravesFilter"), false, this.handleFilterStateChanged.bind(this), container);
        this.optionsList.appendChild(container);

        this.typeOptionsList = document.createElement("ul");
        let li = document.createElement("li");
        li.id = "map-type-filter-options";
        let p = document.createElement("p");
        p.innerText = getLocalizedText("controlGraveType");
        li.appendChild(p);
        li.appendChild(this.typeOptionsList);
        this.optionsList.appendChild(li);

        this.collapsibleContent.appendChild(this.optionsList);
    }

    updateFilterOptions(options: string[]) {
        removeChildren(this.typeOptionsList);
        options.map((graveType, index) => {
            if (graveType.trim() !== "") {
                let container = document.createElement("li");
                this.generateCheckBox("optType"+index, graveType, false, this.handleFilterStateChanged.bind(this), this.typeOptionsList);
                this.typeOptionsList.appendChild(container);
            }
        });
    }

    setPaymentFiltersVisibility(visible: boolean) {
        let debtorsFilterContainer = document.getElementById("optUnpaid")?.parentElement;
        if (debtorsFilterContainer) {
            debtorsFilterContainer.style.display = visible ? "" : "none";
        }
        let contractFilterContainer = document.getElementById("optNoContract").parentElement;
        if (contractFilterContainer) {
            contractFilterContainer.style.display = visible ? "" : "none";
        }
    }

    private handleFilterStateChanged() {
        if (this.filterStateChangeHandler) {
            let graveTypes:string[] = [];
            let checkboxes = this.typeOptionsList.getElementsByTagName("input");
            for (let i=0; i<checkboxes.length; i++) {
                let cb = checkboxes.item(i);
                if (cb.checked) {
                    graveTypes.push(cb.value);
                }
            }
            let newState: IFilterState = {
                emptyGraves: (document.getElementById("optEmpty") as HTMLInputElement).checked,
                noContract: (document.getElementById("optNoContract") as HTMLInputElement).checked,
                projected: (document.getElementById("optProjected") as HTMLInputElement).checked,
                unpaidGraves: (document.getElementById("optUnpaid") as HTMLInputElement).checked,
                graveTypes: graveTypes
            }
            this.filterStateChangeHandler(newState);
        }
    }
}